import React from 'react';
import './Faq.scss';
import { getLang } from 'Config/utils-config/marketGetters';

const {
    FAQ_WIDGET_NON_PROD,
    FAQ_WIDGET_PROD,
    CMS_LOCALE_LANGUAGE,
    PHRASE_TRANSLATIONS,
    MARKET_NAME,
    HIDE_FAQ,
} = process.env.REACT_APP_MARKET_VALUES;
const FAQ_LANG_ACCORDION = getLang(MARKET_NAME);
const showVetaArticles = !HIDE_FAQ;
const widgetResult =
    window.location.hostname === 'www.ikea.com' ? FAQ_WIDGET_PROD : FAQ_WIDGET_NON_PROD;
const Faq = () => (
    <div className="faq">
        <h2 className="faq__headline">{PHRASE_TRANSLATIONS.searchHeadline}</h2>
        <div data-cy="faq">
            <km-search-integration lang={CMS_LOCALE_LANGUAGE}></km-search-integration>
            {showVetaArticles && (
                <div className="accordion-override-wrapper">
                    <km-faq-accordion
                        listTitle=""
                        widget={widgetResult}
                        faqLang={FAQ_LANG_ACCORDION}
                    ></km-faq-accordion>
                </div>
            )}
        </div>
    </div>
);

export default Faq;
